/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_IntervalInputs */

const en_settings_billing_interval = /** @type {(inputs: Settings_Billing_IntervalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interval`)
};

/**
* | output |
* | --- |
* | "Interval" |
*
* @param {Settings_Billing_IntervalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_interval = /** @type {((inputs?: Settings_Billing_IntervalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_IntervalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_interval(inputs)
});
export { settings_billing_interval as "settings.billing.interval" }